module.exports = __webpack_public_path__ + "img/search.d43ad08a.svg";